import React from 'react'
import { Link } from 'gatsby'
import erpImg from '../images/ERP-01 2.png'
import customImg from '../images/Custom/CustDevelopment.png'
import aiImg from '../images/AI-01 1.png'

const banners = [
  {
    eyebrow: 'ERP Solutions',
    title: 'Expert ERP Implementation.',
    titleAccent: 'Proven Results.',
    description:
      'Optimize your business with certified Odoo and Microsoft Dynamics 365 implementations — delivered on time, within budget, and built to scale.',
    cta: 'Explore ERP Services',
    ctaLink: '/OdooServices',
    image: erpImg,
    colors: {
      card: '#1e0828',
      decoBase: '#3d0840',
      decoMid: '#5c1048',
      blob1: '#c1453a',
      blob2: '#9b1f56',
      blob3: '#e8634a',
    },
  },
  {
    eyebrow: 'Custom Development',
    title: 'Custom Software.',
    titleAccent: 'Your Vision, Delivered.',
    description:
      'From enterprise web platforms to cross-platform mobile apps, our engineers build scalable, high-performance solutions tailored precisely to your needs.',
    cta: 'View Our Portfolio',
    ctaLink: '/CustomDevelopment',
    image: customImg,
    colors: {
      card: '#051428',
      decoBase: '#082040',
      decoMid: '#0a3060',
      blob1: '#0a6fa8',
      blob2: '#0c84cc',
      blob3: '#38b6f0',
    },
  },
  {
    eyebrow: 'AI & Analytics',
    title: 'Data-Driven Intelligence.',
    titleAccent: 'Transformative Growth.',
    description:
      'Turn raw data into strategic advantage with custom Power BI dashboards, predictive AI models, and intelligent business automation.',
    cta: 'Explore AI Solutions',
    ctaLink: '/AI',
    image: aiImg,
    colors: {
      card: '#041a10',
      decoBase: '#062818',
      decoMid: '#08381e',
      blob1: '#0a7a48',
      blob2: '#0e9e5a',
      blob3: '#2cd882',
    },
  },
]

/* Inline SVG blobs so each card's shapes are truly organic */
const DecoBlob = ({ cx, cy, rx, ry, rotate, color, opacity = 1 }) => (
  <ellipse
    cx={cx}
    cy={cy}
    rx={rx}
    ry={ry}
    fill={color}
    opacity={opacity}
    transform={`rotate(${rotate} ${cx} ${cy})`}
    style={{ filter: 'blur(2px)' }}
  />
)

const BannerCard = ({ eyebrow, title, titleAccent, description, cta, ctaLink, image, colors }) => (
  <div className="vb-card" style={{ '--card-bg': colors.card }}>
    {/* ── Left: text content ── */}
    <div className="vb-card__content">
      <span className="vb-card__eyebrow">{eyebrow}</span>
      <h2 className="vb-card__title">
        {title}
        <br />
        {titleAccent}
      </h2>
      <p className="vb-card__desc">{description}</p>
      <Link to={ctaLink}>
        <button className="vb-card__cta">{cta}</button>
      </Link>
    </div>

    {/* ── Right: image decoration ── */}
    <div className="vb-card__deco">
      <img src={image} alt="" className="vb-card__deco-img" />
    </div>
  </div>
)

const BannerCards = () => (
  <section className="vb-section">
    <div className="vb-stack">
      {banners.map((b, i) => (
        <BannerCard key={i} {...b} />
      ))}
    </div>
  </section>
)

export default BannerCards
